export default function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-20 scroll-mt-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
          联系我们
        </h2>
        <p className="text-sm text-foreground-500 mb-10">
          触手漫画网欢迎你的反馈与投稿
        </p>
        <div className="bg-background-100 rounded-2xl p-8 md:p-10 border border-background-200/60">
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
            如果你有触手漫画推荐、网站反馈或合作意向，欢迎通过以下方式与我们联系。
            我们也长期接受触手漫画相关的投稿与建议，期待你的声音！
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <div className="flex items-center gap-2 text-sm text-foreground-600">
              <i className="ri-mail-line text-primary-500 text-lg"></i>
              <span>contact@chushoumanhua.com</span>
            </div>
            <span className="hidden sm:block text-foreground-300">|</span>
            <div className="flex items-center gap-2 text-sm text-foreground-600">
              <i className="ri-message-2-line text-primary-500 text-lg"></i>
              <span>在线反馈：发送邮件至上方地址</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}